export default __webpack_public_path__ + "static/media/garrett.d371f029.jpg";